import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { useGlobalModalLaunchContext } from '../../../../../../contexts/modal-context/global-modal-context';
import { usePaymentAndSubscriptionMegaContext } from '../../../context/index';
import { useTrackPromoModal } from '../hooks/use-track-promo-modal';
import { modalMessages } from '../messages';

const ActionButton = ({ isActionDisabled, onClick, buttonMessage }) => (
  <Button disabled={isActionDisabled} onClick={onClick} theme={THEME_CONSTANTS.primary}>
    <FormattedMessage {...buttonMessage} />
  </Button>
);

/**
 * @param {object} props
 * @param {boolean} props.isActionDisabled
 * @param {() => void} props.onAction
 * @returns {React.JSX.Element}
 */
export const MigrationModalActionButton = ({ isActionDisabled, onAction }) => {
  const { hasLegacyRecurlyBillingInfo, isMissingPaymentMethod } = usePaymentAndSubscriptionMegaContext();
  const { openBillingInfoModal } = useGlobalModalLaunchContext();
  const { trackPromoAddPaymentClickEvent, trackPromoAddPaymentCompleteEvent } = useTrackPromoModal();

  const openModalToAddPaymentMethod = useCallback(() => {
    trackPromoAddPaymentClickEvent();
    openBillingInfoModal({ trackConfirmClick: trackPromoAddPaymentCompleteEvent });
  }, [openBillingInfoModal, trackPromoAddPaymentClickEvent, trackPromoAddPaymentCompleteEvent]);

  const shouldShowAddPaymentButton = !hasLegacyRecurlyBillingInfo && isMissingPaymentMethod;

  return (
    <ActionButton
      buttonMessage={shouldShowAddPaymentButton ? modalMessages.addPaymentMethodButton : modalMessages.upgradeSubscriptionButton}
      isActionDisabled={isActionDisabled}
      onClick={shouldShowAddPaymentButton ? openModalToAddPaymentMethod : onAction}
    />
  );
};
